module.exports = __webpack_public_path__ + "static/media/bleeding-hearts-1201.eee9fd3a.jpg";